

















import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import {
  Meter,
  ResCode,
  PowerConditionerTableData,
  SimplifyMeter,
} from "@/api/baseDefine";
import {
  SendDataReq,
  sendData,
  meters,
  GetPowerConditionerDataReq,
  getPowerConditionerData,
  PowerConditioner,
} from "@/api/meter";
import { formatDate, formatDateTime } from "../../utils/dateUtil";
@Component
export default class VersionCheckDialog extends Vue {
  @Prop({ default: null, required: true }) private meters!: Meter[];
  private versionCheckDialogShow: boolean = false;
  private clickShow() {
    if (this.meters.length <= 0) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("powerConditioner.onlyOneMeterSupport").toString(),
        type: "warning",
      });
      return;
    }
    this.versionCheckDialogShow = true;
  }

  private async sendData() {
    let req: SendDataReq = <SendDataReq>{};
    req.meterIDs = this.getMeterIDs();
    req.dataType = 1;
    req.params = "5";
    let res = await sendData(req);
    if (res.code == ResCode.SUCCESS) {
      this.versionCheckDialogShow = false;
    }
  }

  private getMeterIDs() {
    let meterIDS: {
      meterID: string;
      meterTypeID: number;
    }[] = [];
    for (let item of this.meters) {
      let meterID: {
        meterID: string;
        meterTypeID: number;
      } = {
        meterID: item.meterID,
        meterTypeID: item.meterTypeID,
      };
      meterIDS.push(meterID);
    }
    return meterIDS;
  }
}
